import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { WhatsAppIcon } from './Logo';

const WhatsAppFloat = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="whatsapp-float-root"
      style={{
        position: 'fixed',
        bottom: '28px',
        right: '28px',
        zIndex: 999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '12px',
      }}
    >
      {/* Tooltip bubble */}
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            className="whatsapp-tooltip"
            initial={{ opacity: 0, y: 8, scale: 0.92 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.92 }}
            transition={{ duration: 0.22 }}
            style={{
              background: '#0d1b35',
              border: '1px solid rgba(37,211,102,0.25)',
              borderRadius: '14px',
              padding: '14px 18px',
              maxWidth: '230px',
              boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
              position: 'relative',
            }}
          >
            <p
              style={{
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 700,
                fontSize: '0.88rem',
                color: '#fff',
                marginBottom: '4px',
              }}
            >
              Chat with us
            </p>
            <p
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.78rem',
                color: '#64748b',
                lineHeight: 1.5,
              }}
            >
              Usually replies within minutes
            </p>
            {/* Arrow */}
            <div
              style={{
                position: 'absolute',
                bottom: '-6px',
                right: '22px',
                width: '12px',
                height: '12px',
                background: '#0d1b35',
                border: '1px solid rgba(37,211,102,0.25)',
                borderTop: 'none',
                borderLeft: 'none',
                transform: 'rotate(45deg)',
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating button */}
      <motion.a
        className="whatsapp-float-btn"
        href="https://wa.me/916289350762?text=Hi%20InsightsNode!%20I%27d%20like%20to%20discuss%20a%20project."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-float-btn"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.5, type: 'spring', stiffness: 260, damping: 20 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        style={{
          width: '58px',
          height: '58px',
          borderRadius: '50%',
          background: '#25d366',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          boxShadow: '0 4px 20px rgba(37,211,102,0.4), 0 0 0 0 rgba(37,211,102,0.4)',
          animation: 'whatsapp-pulse 2.5s ease-out infinite',
        }}
      >
        <WhatsAppIcon size={28} color="#ffffff" />
      </motion.a>
    </div>
  );
};

export default WhatsAppFloat;
